import { TABLE_TRANSITION_MS } from 'contexts/ViewManagerContext';

// The view-switch debounce drops a navigation silently (openTable returns
// false, returnToLobby returns nothing), which would leave the player on the
// view they were leaving. Recheck past the debounce until the view has left it.
export const EXIT_NAVIGATION_RETRY_MS = TABLE_TRANSITION_MS + 50;
export const EXIT_NAVIGATION_ATTEMPTS = 3;

// Read from the URL, not React state: the component that ran the navigation can
// unmount with its table, and its state would then never update.
export const isStillOnTable = (gameID: string): boolean =>
  window.location.pathname.startsWith(`/table/${gameID}/`);

/**
 * A navigation to the lobby out of this table has not happened yet: the view is
 * still on the table, or still on the grid (whose URL never names the table).
 */
export const isStillOffLobby = (gameID: string): boolean =>
  isStillOnTable(gameID) || window.location.pathname.startsWith('/grid');

/**
 * Run `move`, then run it again past the debounce while `pending()` holds, at
 * most EXIT_NAVIGATION_ATTEMPTS times in all.
 */
export const retryPastTransition = (pending: () => boolean, move: () => void): void => {
  move();
  let attempts = 1;
  const recheck = () => {
    if (!pending() || attempts >= EXIT_NAVIGATION_ATTEMPTS) return;
    attempts += 1;
    move();
    setTimeout(recheck, EXIT_NAVIGATION_RETRY_MS);
  };
  setTimeout(recheck, EXIT_NAVIGATION_RETRY_MS);
};
